<template>
  <!-- Modal for Sowftare Application -->
  <el-dialog :visible.sync="show"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :show-close="false"
             width="350px">
    <div class="top-container">
      <div class="top-title">{{languages.modify}}</div>
      <div class="top-close"><i class="el-icon-circle-close"
           @click="Hide"></i></div>
    </div>
    <div class="bottom-content">
      <div class="seat-title">{{languages.seat}}</div>
      <el-input class="seat-input"
                :value="seat"
                v-model="seatVal"
                clearable
                :placeholder="languages.seatTip"></el-input>
      <div class="phone-title">{{languages.ext}}</div>
      <el-input class="phone-input"
                :value="phone"
                v-model="phoneVal"
                clearable
                :placeholder="languages.extTip"></el-input>
      <el-button class="bottom-confirm"
                 size="mini"
                 type="primary"
                 @click="Submit">{{languages.confirm}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      seatVal: '',
      phoneVal: '',
    };
  },
  watch: {
    seat (val) {
      this.seatVal = val;
    },
    phone (val) {
      this.phoneVal = val;
    },
  },
  props: {
    languages: Object,
    show: Boolean,
    seat: String,
    phone: String,
  },
  methods: {
    Hide () {
      this.$parent.hideModifyDialog();
    },
    Submit () {
      this.$parent.submitModify(this.seatVal, this.phoneVal);
    },
  },
};
</script>

<style lang="scss" scoped>
.top-container {
  margin-top: -20px;
  position: relative;
  height: 40px;
  color: #fff;
  border-top-left-radius: 1px;
  border-top-right-radius: 1px;
  background-image: linear-gradient(to right, #00b7ff, #0080ff);
  .top-title {
    position: absolute;
    left: 10px;
    top: 10px;
  }
  .top-close {
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 18px;
    cursor: pointer;
  }
}
.bottom-content {
  height: 200px;
  position: relative;
  flex-direction: column;
  .seat-title,
  .phone-title {
    position: absolute;
    left: 20px;
    top: 30px;
    width: 60px;
    height: 40px;
    line-height: 40px;
    text-align: right;
  }
  .phone-title {
    top: 80px;
  }
  .seat-input,
  .phone-input {
    position: absolute;
    left: 90px;
    top: 30px;
    width: 230px;
  }
  .phone-input {
    top: 80px;
  }

  .bottom-confirm {
    position: absolute;
    right: 30px;
    bottom: 30px;
    width: 100px;
    font-size: 16px;
  }
}
</style>
